import { useEffect } from 'react'
import { Box } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import { MarketingAppbar } from './marketing-appbar'
import { MarketingFooter } from './marketing-footer'
import { APPBAR_HEIGHT_REM, APPBAR_EXTRA_DESKTOP_REM } from '~/common/constants/layout-constants'

export const MarketingLayout = () => {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <MarketingAppbar />
      <Box component="main" sx={{ pt: { xs: `calc(${APPBAR_HEIGHT_REM} - ${APPBAR_EXTRA_DESKTOP_REM})`, md: APPBAR_HEIGHT_REM }, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </Box>
      <MarketingFooter />
    </Box>
  )
}
